import { Link } from "react-router-dom";
import { mainServices } from "../../../mocks/services";

export default function ServicesSection() {
  return (
    <section className="bg-[#F8F7F4] py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Header */}
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between mb-14 gap-6">
          <div>
            <p className="text-[#E8500A] font-bold text-xs tracking-widest uppercase mb-3">Our Services</p>
            <h2
              className="text-4xl lg:text-5xl font-black text-gray-900 leading-tight"
              style={{ fontFamily: "'Barlow', sans-serif" }}
            >
              Plumbing &amp; Heating
              <br />
              <span className="text-[#E8500A]">Services We Offer</span>
            </h2>
          </div>
          <p className="text-gray-500 text-base max-w-md leading-relaxed">
            From emergency plumbing repairs to full installations and commercial welding — we handle every aspect of your property's needs with precision and care.
          </p>
        </div>

        {/* Service Cards Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-5 mb-10">
          {mainServices.map((service, idx) => (
            <Link
              key={service.id}
              to={service.href}
              className="group bg-white hover:bg-[#E8500A] rounded-2xl p-7 transition-all duration-300 hover:scale-[1.02] cursor-pointer border border-gray-100 hover:border-[#E8500A]"
            >
              {/* Number + icon */}
              <div className="flex items-start justify-between mb-5">
                <div className="w-14 h-14 flex items-center justify-center bg-orange-50 group-hover:bg-white/15 rounded-xl transition-colors">
                  <img
                    src={service.icon}
                    alt={service.iconAlt}
                    className="w-9 h-9 object-contain"
                  />
                </div>
                <span
                  className="text-gray-200 group-hover:text-white/20 font-black text-4xl leading-none transition-colors"
                  style={{ fontFamily: "'Barlow', sans-serif" }}
                >
                  {String(idx + 1).padStart(2, "0")}
                </span>
              </div>

              <h3
                className="font-black text-lg text-gray-900 group-hover:text-white mb-2.5 transition-colors"
                style={{ fontFamily: "'Barlow', sans-serif" }}
              >
                {service.title}
              </h3>
              <p className="text-gray-500 group-hover:text-white/75 text-sm leading-relaxed mb-5 transition-colors">
                {service.description}
              </p>

              <ul className="space-y-1.5 mb-6">
                {service.items.slice(0, 4).map((item) => (
                  <li
                    key={item}
                    className="flex items-center gap-2 text-xs text-gray-500 group-hover:text-white/70 transition-colors"
                  >
                    <i className="ri-check-line text-[#E8500A] group-hover:text-white flex-shrink-0" />
                    {item}
                  </li>
                ))}
              </ul>

              <span className="inline-flex items-center gap-1.5 text-[#E8500A] group-hover:text-white font-bold text-sm transition-colors">
                Learn More <i className="ri-arrow-right-line" />
              </span>
            </Link>
          ))}
        </div>

        {/* Mid-section CTA banner */}
        <div className="bg-[#0B1829] rounded-2xl p-8 lg:p-10 flex flex-col lg:flex-row items-center justify-between gap-6">
          <div className="flex items-center gap-5 flex-1">
            <div className="w-14 h-14 flex items-center justify-center bg-[#E8500A]/15 rounded-xl flex-shrink-0">
              <i className="ri-alarm-warning-line text-2xl text-[#E8500A]" />
            </div>
            <div>
              <h3
                className="font-black text-xl text-white mb-1"
                style={{ fontFamily: "'Barlow', sans-serif" }}
              >
                Plumbing Emergency? We Respond Fast.
              </h3>
              <p className="text-gray-400 text-sm">
                24/7 emergency plumbing and heating service across all of Dallas–Fort Worth.
              </p>
            </div>
          </div>
          <div className="flex flex-wrap gap-3 flex-shrink-0">
            <a
              href="tel:8178324968"
              className="flex items-center gap-2 bg-[#E8500A] hover:bg-[#d14508] text-white font-bold px-6 py-3.5 rounded-lg text-sm transition-colors whitespace-nowrap"
            >
              <i className="ri-phone-fill" /> Call (817) 832-4968
            </a>
            <Link
              to="/contact"
              className="flex items-center gap-2 border border-white/20 hover:border-white text-white font-semibold px-6 py-3.5 rounded-lg text-sm transition-colors whitespace-nowrap"
            >
              Get Free Estimate
            </Link>
          </div>
        </div>

        {/* Service detail list strip */}
        <div className="grid lg:grid-cols-2 gap-6 mt-6">
          <div className="bg-white rounded-2xl p-8 border border-gray-100">
            <div className="flex items-center gap-3 mb-5">
              <div className="w-10 h-10 flex items-center justify-center bg-orange-50 rounded-xl">
                <i className="ri-water-flash-line text-[#E8500A] text-lg" />
              </div>
              <h3
                className="font-black text-gray-900 text-lg"
                style={{ fontFamily: "'Barlow', sans-serif" }}
              >
                Plumbing Services Include
              </h3>
            </div>
            <ul className="grid grid-cols-2 gap-2">
              {mainServices[0].items.map((item) => (
                <li key={item} className="flex items-center gap-2 text-gray-600 text-sm">
                  <i className="ri-checkbox-circle-fill text-[#E8500A] flex-shrink-0 text-xs" />
                  {item}
                </li>
              ))}
            </ul>
          </div>
          <div className="bg-white rounded-2xl p-8 border border-gray-100">
            <div className="flex items-center gap-3 mb-5">
              <div className="w-10 h-10 flex items-center justify-center bg-orange-50 rounded-xl">
                <i className="ri-hammer-line text-[#E8500A] text-lg" />
              </div>
              <h3
                className="font-black text-gray-900 text-lg"
                style={{ fontFamily: "'Barlow', sans-serif" }}
              >
                Welding Services Include
              </h3>
            </div>
            <ul className="grid grid-cols-2 gap-2">
              {mainServices[1].items.map((item) => (
                <li key={item} className="flex items-center gap-2 text-gray-600 text-sm">
                  <i className="ri-checkbox-circle-fill text-[#E8500A] flex-shrink-0 text-xs" />
                  {item}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
